// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._921dKI8MlLMTkb5Mjus-fw\\=\\={display:flex;flex-direction:column;gap:var(--xds-spacing-a);align-items:flex-end;padding-top:var(--xds-spacing-a)}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardCourierListItem/DashboardCourierListItem.module.scss"],"names":[],"mappings":"AAAA,6BACI,YAAA,CACA,qBAAA,CACA,wBAAA,CACA,oBAAA,CACA,gCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trailing": "_921dKI8MlLMTkb5Mjus-fw=="
};
export default ___CSS_LOADER_EXPORT___;
